module.exports = __webpack_public_path__ + "fonts/unicredit-bold.7026da88.eot";